import {hero} from "./hero.js";
import {resultSection} from "./result.js";

export const generalSections = ()=> {
    hero();

    resultSection();
}